import { Warning } from '@project-lary/react-material-symbols-400-rounded';
import IconComponent from 'gcs-common/components/Icon/Icon';
import { ICON, ICON_COLOR } from 'gcs-common/constants/IconConstants';
import {
  MAINTENANCE_BANNER_DISMISSED_KEY,
  MAINTENANCE_BANNER_END,
  MAINTENANCE_BANNER_START,
} from 'gcs-common/constants/maintenanceConstants';
import { useEffect, useState } from 'react';

const MaintenanceBanner = () => {
  const [now, setNow] = useState(() => new Date());
  const [isDismissed, setIsDismissed] = useState(
    () => localStorage.getItem(MAINTENANCE_BANNER_DISMISSED_KEY) === 'true',
  );

  useEffect(() => {
    const currentTime = now.getTime();
    let nextUpdateAt: number | null = null;

    if (currentTime < MAINTENANCE_BANNER_START.getTime()) {
      nextUpdateAt = MAINTENANCE_BANNER_START.getTime();
    } else if (currentTime < MAINTENANCE_BANNER_END.getTime()) {
      nextUpdateAt = MAINTENANCE_BANNER_END.getTime();
    }

    if (nextUpdateAt === null) return;

    const timeout = window.setTimeout(() => setNow(new Date()), Math.max(0, nextUpdateAt - currentTime));

    return () => window.clearTimeout(timeout);
  }, [now]);

  const isWithinWindow = now >= MAINTENANCE_BANNER_START && now < MAINTENANCE_BANNER_END;

  if (!isWithinWindow || isDismissed) return null;

  const handleDismiss = () => {
    localStorage.setItem(MAINTENANCE_BANNER_DISMISSED_KEY, 'true');
    setIsDismissed(true);
  };

  return (
    <div className="absolute top-0 right-0 left-0 z-[20000] box-border flex w-full items-center justify-between gap-2 bg-[var(--theme-primary-lighter)] px-5 py-2.5 text-center text-black text-sm leading-tight opacity-90">
      <Warning className="shrink-0 text-secondary text-xl" />
      <div className="mx-auto">
        Unser Ersatzteilservice-Team ist am <strong>01-02.09.2026</strong> nur eingeschränkt besetzt. Deine Anfrage
        erreicht uns weiterhin und wird schnellstmöglich bearbeitet. In diesem Zeitraum kann es jedoch zu längeren
        Bearbeitungszeiten kommen.
      </div>
      <button
        aria-label="Banner schließen"
        className="flex shrink-0 items-center justify-center"
        type="button"
        onClick={handleDismiss}
      >
        <IconComponent Icon={ICON.CLOSE} color={ICON_COLOR.BLACK} />
      </button>
    </div>
  );
};

export default MaintenanceBanner;
